import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

import { Input, FormGroup, Label } from 'reactstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { provideIntlService } from '@progress/kendo-react-intl';

import {
    setUserInfo,
    checkEmailCall,
    changeView,
    setAlert
} from '../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import { getCounties, setCounties } from '../../../../../Redux/Actions/Admin/ManageDistrictActions';
import { fetchMembershipPackages } from '../../../../../Redux/Actions/EndUser/MembershipAction';

import { fetchStates } from '../../../../../Redux/Actions/CommonActions';

import IsLoading from '../../../../Shared/Loading/IsLoading';
import _ from 'lodash';
import { Alert } from 'reactstrap';

const initialState = {
    view: "CheckUser",
    membershipLookupEmail: "",
    membershipData: [],
    address1: "",
    address2: "",
    applicationUser: {},
    city: "",
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    state: {
        stateId: 0
    },
    countyObj: { countyId: 0, countyName: "" },
    county: "",
    zip: "",
    isLoading: false,
    touched: {
        firstName: false,
        lastName: false,
        address1: false,
        address2: false,
        city: false,
        state: false,
        county: false,
        zip: false,
        phone: false,
        email: false,
    },
};

class MembershipRequestForm extends Component {
	months = [
		{ name: "January", id: 1 },
		{ name: "February", id: 2 },
		{ name: "March", id: 3 },
		{ name: "April", id: 4 },
		{ name: "May", id: 5 },
		{ name: "June", id: 6 },
		{ name: "July", id: 7 },
		{ name: "August", id: 8 },
		{ name: "September", id: 9 },
		{ name: "October", id: 10 },
		{ name: "November", id: 11 },
		{ name: "December", id: 12 },
	];

	years = [];
	showErrorMessage = false;

	getYears = () => {
		var years = [];
		for (var i = (new Date()).getFullYear() + 10; i >= 1900; i--) {
			years.push({ id: i, name: i + '' });
		}

		return years;
	}
	constructor(props) {
		super(props);

		this.years = this.getYears();
		this.state = {
			requestInEdit: this.props.dataItem || null,
            createDate: this.props.dataItem ? this.props.dataItem.CreateDate : '',
            memberRequestEmail: this.props.dataItem ? this.props.dataItem.Email : '',
            memberRequestFirstName: this.props.dataItem ? this.props.dataItem.FirstName : '',
            memberRequestLastName: this.props.dataItem ? this.props.dataItem.LastName : '',
            memberRequestMemberNumber: this.props.dataItem ? this.props.dataItem.MemberNumber : '',
            membershipRequestId: this.props.dataItem ? this.props.dataItem.MembershipRequestId : '',
            memberRequestPhoneNumber: this.props.dataItem ? this.props.dataItem.PhoneNumber : '',
            status: this.props.dataItem ? this.props.dataItem.Status : '',
            ...initialState
        };

        this.delayedCallback = _.debounce(this.checkEmailCall, 2000);
        this.onEmailChange = this.onEmailChange.bind(this);
	};

	componentDidMount() {

    }

    componentDidMount() {
        this.props.fetchStates();
    }

    checkEmailCall = () => {
        this.setState({ isLoading: true })
        const options = { method: 'POST', headers: auth.authHeader() };
        axios.get(`${ROOT_API_URL}/ManageTransaction/SearchMembership?searchTerm=${this.state.membershipLookupEmail}`, options)
            .then((response) => {
                if (response.data.length > 0) {
                    //console.log(response.data);
                    this.setState({
                        membershipData: response.data,
                        isLoading: false
                    },
                        () => {
                            this.props.setAlert(true, "Users Found", 'success')
                        }
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else if (response.data.length === 0) {
                    this.setState({
                        ...initialState,
                        membershipLookupEmail: this.state.membershipLookupEmail,
                        membershipData: response.data,
                        isLoading: false
                    },
                        () => this.props.setAlert(true, "No Users Found", 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else {
                    this.setState({
                        ...initialState,
                        membershipLookupEmail: this.state.membershipLookupEmail,
                        isLoading: false
                    },
                        () => this.props.setAlert(true, response.data.message, 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                }
            })
            .catch((response) => {
                this.setState({ isLoading: false }, () => this.props.setAlert(true, response.message, 'danger'))
            });
    }

    onEmailChange = (event) => {
        var userId = '';
        if (auth.isAuthenticated()) {
            userId = auth.getAuthUserId()
        }
        this.setState(
            {
                membershipLookupEmail: event.target.value

            },
            () => {
                this.delayedCallback();
            }

        );
    };

    handleChange = ({ target }) => {
        this.setState({ [target.name]: target.value });
    };

    handleState = (event) => {
        this.props.getCounties(event.target.value.id);
        const value = event.target.value;
        if (value !== null) {
            this.setState({ state: value });
        }
    };

    selectCountyInDD = (event) => {
        this.setState({
            countyObj: event.target.value
        })
    }

    formatPhone = (val) => {
        if (!val) return val;
        var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                firstName: true,
                lastName: true,
                address1: true,
                address2: true,
                city: true,
                state: true,
                zip: true,
                phone: true,
                email: true,
                county: true,
            }
        })
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    isModelValid() {
        return this.state.address1 !== "" &&
            this.state.city !== "" &&
            this.state.zip !== "" &&
            this.state.phone !== "" &&
            this.state.firstName !== "" &&
            this.state.lastName !== "" &&
            this.state.email !== "" &&
            this.state.countyObj.countyName !== "";
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        if (this.isModelValid()) {
            this.setState({ isLoading: true });

            this.props.toggleIsSubmitted(true);
            const options = { method: 'POST', headers: auth.authHeader() };
            await axios.post(
                `${ROOT_API_URL}/MemberInvitation/UpdateMembershipUserInvite`,
                {
                    MailingAddress1: this.state.address1,
                    MailingAddress2: this.state.address2,
                    MailingCity: this.state.city,
                    MailingZip: this.state.zip,
                    Phone: this.state.phone,
                    MailingStateId: this.state.mailingStateId,
                    State: this.state.state,
                    FirstName: this.state.firstName,
                    LastName: this.state.lastName,
                    UserID: this.state.userId,
                    Email: this.state.email,
                    County: this.state.countyObj,
                    MembershipAssignmentId: this.state.membershipAssignmentId,
                    MembershipId: this.state.membershipId,
                    IsMembershipOwner: true
                },
                options
            ).then(async (response) => {

                this.props.setAlert(true, response.data.message, 'success');
                //this.props.cancel();
                setTimeout(() => {
                    this.props.setAlert(false, "");
                }, 5000);

                await this.reject(null, "resolve");
                                  
            }).catch((response) => {
                this.setState({ isLoading: false }, () => this.props.setAlert(true, response.message, 'danger'))
            });

        } else {
            this.setAllTouchedTrue();
        }
    }

    resendEmail = async (event) => {

        event.preventDefault();

        if (this.isModelValid()) {
            this.setState({ isLoading: true });

            this.props.toggleIsSubmitted(true);
            const options = { method: 'POST', headers: auth.authHeader() };
            await axios.post(
                `${ROOT_API_URL}/MemberInvitation/ResendEmail`,
                {
                    MailingAddress1: this.state.address1,
                    MailingAddress2: this.state.address2,
                    MailingCity: this.state.city,
                    MailingZip: this.state.zip,
                    Phone: this.state.phone,
                    MailingStateId: this.state.mailingStateId,
                    State: this.state.state,
                    FirstName: this.state.firstName,
                    LastName: this.state.lastName,
                    UserID: this.state.userId,
                    Email: this.state.email,
                    County: this.state.countyObj,
                    MembershipAssignmentId: this.state.membershipAssignmentId,
                    MembershipId: this.state.membershipId,
                    IsMembershipOwner: true
                },
                options
            ).then(async (response) => {

                if (response && response.data && !response.data.isSuccess) {

                    this.props.setAlert(true, response.data.message, 'danger');
                } else {
                    this.props.setAlert(true, response.data.message, 'success');

                }

                //this.props.cancel();
                setTimeout(() => {
                    this.props.setAlert(false, "");
                }, 5000);

                this.setState({ isLoading: false });
                this.props.toggleIsSubmitted(false);
                this.props.cancel();

            }).catch((response) => {
                this.setState({ isLoading: false }, () => this.props.setAlert(true, response.message, 'danger'))
            });

        } else {
            this.setAllTouchedTrue();
        }
    }

    handlePhoneChange = (event) => {
        event.target.value = this.formatPhone(event.target.value);
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleMembershipSelectChange = (event) => {
        if (event.target.value !== null) {
            this.props.fetchMembershipPackages(event.target.value.membershipType.membershipTypeID);
            this.setState({
                firstName: event.target.value.firstName,
                lastName: event.target.value.lastName,
                email: event.target.value.email,
                address1: event.target.value.mailingAddress1,
                address2: event.target.value.mailingAddress2,
                city: event.target.value.mailingCity,
                zip: event.target.value.mailingZip,
                mailingStateId: event.target.value.state.id,
                state: event.target.value.state,
                countyObj: event.target.value.countyObj || { countyId: 0, countyName: "" },
                county: event.target.value.countyObj ? event.target.value.countyObj.countyId : '',
                phone: event.target.value.phone,
                membershipId: event.target.value.membershipId,
                userId: event.target.value.userID,
                membershipAssignmentId: event.target.value.membershipAssignmentId
            });

            this.props.getCounties(event.target.value.state.id);
        }
    }

    reject = async (event, rejectType) => {
        // prevent the event default action.
        if (event) {
            event.preventDefault();
        }

        const options = { method: 'POST', headers: auth.authHeader() };

        this.props.toggleIsSubmitted(true);

        await axios.post(`${ROOT_API_URL}/ManageMembershipRequest/UpdateMemberRequest`, {
            RequestId: this.state.membershipRequestId,
            Type: rejectType
        }, options)
            .then((response) => {
                this.props.setAlert(true, response.data.message, 'success');
                setTimeout(() => {
                    this.props.setAlert(false, "");
                }, 5000);

                this.setState({ isLoading: false });

                this.props.toggleIsSubmitted(false);
                this.props.cancel();
            })
            .catch((response) => {
                this.setState({ isLoading: false }, () => this.props.setAlert(true, response.message, 'danger'))
            });

    }

	render() {
		return (
			<div className="memberRequestsForm">
				<Dialog onClose={this.props.cancel}>
					<form className="">
                        <div className="row">
                            <div className="col-md-4 requestInfo">
                                <div>
                                    <label>Create Date: </label>
                                    {" " + provideIntlService(this).formatDate((new Date(this.state.createDate)), 'MM/d/y')}
                                </div>
                                <div>
                                    <label>Email: </label>
                                    {" " + this.state.memberRequestEmail}
                                </div>
                                <div>
                                    <label>First Name: </label>
                                    {" " + this.state.memberRequestFirstName}
                                </div>
                                <div>
                                    <label>Last Name: </label>
                                    {" " + this.state.memberRequestLastName}
                                </div>
                                <div>
                                    <label>Member Number: </label>
                                    {" " + this.state.memberRequestMemberNumber}
                                </div>
                                <div>
                                    <label>Request Id: </label>
                                    {" " + this.state.membershipRequestId}
                                </div>
                                <div>
                                    <label>Phone Number: </label>
                                    {" " + this.state.memberRequestPhoneNumber}
                                </div>
                                <div>
                                    <label>Status: </label>
                                    {" " + this.state.status}
                                </div>
                            </div>
                            <div className="col-md-8">
                                <FormGroup>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label htmlFor="exampleEmail" className="label-header">Membership Lookup: </label>
                                            <Input name="membershipLookupEmail" id="membershipLookupEmail" value={this.state.membershipLookupEmail}
                                                onChange={this.onEmailChange}
                                                type="text"
                                                placeholder="Please enter member ID, email, name, or org name." />
                                        </div>
                                    </div>
                                    {this.state.membershipData.length > 0 ?
                                        <div className="row">
                                            <div className="form-group col-md-12">
                                                <label htmlFor="subscriptionId">Please Select Member</label>
                                                <DropDownList data={this.state.membershipData}
                                                    textField="fullConcatinatedMembershipString"
                                                    dataItemKey="membershipId"
                                                    onChange={this.handleMembershipSelectChange}
                                                    value={this.state.selectedMember}
                                                    allowCustom={false}
                                                    filterable={false}
                                                    clearButton={false}
                                                    width={300}
                                                    required={true}
                                                />
                                            </div>
                                        </div> : ""
                                    }
                                </FormGroup>
                                {
                                    this.props.purchaseAndRenewals.purchaseLoading ? (
                                        <IsLoading message="Loading User Information" />
                                    ) : (this.state.isLoading ?
                                    (<IsLoading message="Loading..." />)
                                    :(
                                    <div>

                                        <Alert
                                            color={this.props.purchaseAndRenewals.color}
                                            isOpen={this.props.purchaseAndRenewals.visible}
                                            style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
                                        >
                                            {this.props.purchaseAndRenewals.message}
                                        </Alert>
                                        {this.props.purchaseAndRenewals.userInfo ? <h1>Please look over info</h1> : <h1>Please enter new user info</h1>}
                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="firstName" className={this.state.touched.firstName && this.state.firstName === '' ? "error" : ""}>First Name</label>
                                                <Input
                                                    id="firstName"
                                                    type="text"
                                                    value={this.state.firstName || ""}
                                                    onChange={this.handleChange}
                                                    name="firstName"
                                                    invalid={this.state.touched.firstName && this.state.firstName === '' ? true : false}
                                                    onBlur={this.handleBlur('firstName')}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="lastName" className={this.state.touched.lastName && this.state.lastName === '' ? 'error' : ''}>Last Name</label>
                                                <Input
                                                    id="lastName"
                                                    type="text"
                                                    value={this.state.lastName || ""}
                                                    onChange={this.handleChange}
                                                    name="lastName"
                                                    invalid={this.state.touched.lastName && this.state.lastName === '' ? true : false}
                                                    onBlur={this.handleBlur('lastName')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="address1" className="">Address 1</label>
                                                <Input
                                                    id="address1"
                                                    type="text"
                                                    value={this.state.address1 || ""}
                                                    onChange={this.handleChange}
                                                    name="address1"
                                                    invalid={this.state.touched.address1 && this.state.address1 === '' ? true : false}
                                                    onBlur={this.handleBlur('address1')}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="address2" className="">Address 2</label>
                                                <Input
                                                    id="address2"
                                                    type="text"
                                                    value={this.state.address2 || ""}
                                                    onChange={this.handleChange}
                                                    name="address2"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="form-group col-md-3">
                                                <label htmlFor="city" className="">City</label>
                                                <Input
                                                    id="city"
                                                    type="text"
                                                    value={this.state.city || ""}
                                                    onChange={this.handleChange}
                                                    name="city"
                                                    invalid={this.state.touched.city && this.state.city === '' ? true : false}
                                                    onBlur={this.handleBlur('city')}
                                                />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label>State</label>
                                                <DropDownList data={this.props.common.states}
                                                    id="State"
                                                    name="state"
                                                    textField="name"
                                                    dataItemKey="id"
                                                    onChange={this.handleState}
                                                    value={this.state.state}
                                                />
                                            </div>
                                            {
                                                this.props.district.counties.length > 0 ?
                                                    <div className="form-group col-md-3">
                                                        <label htmlFor="County">County</label>
                                                        <DropDownList data={this.props.district.counties}
                                                            id="County"
                                                            name="county"
                                                            textField="countyName"
                                                            dataItemKey="countyId"
                                                            onChange={this.selectCountyInDD}
                                                            value={this.state.countyObj}
                                                            className={this.state.touched.county && this.state.countyObj.countyName === '' ? "error" : ""}
                                                            onBlur={this.handleBlur('county')}
                                                        />
                                                    </div>
                                                    : ""
                                            }
                                            <div className="form-group col-md-3">
                                                <label htmlFor="zip" className="">Zip</label>
                                                <Input
                                                    id="zip"
                                                    vakudutystyles="false"
                                                    value={this.state.zip}
                                                    onChange={this.handleChange}
                                                    name="zip"
                                                    pattern="(\d{5}([\-]\d{4})?)"
                                                    type="text"
                                                    placeholder="12345"
                                                    title="Zip Code (Format: 12345 or 12345-6789)"
                                                    invalid={this.state.touched.zip && this.state.zip === '' ? true : false}
                                                    onBlur={this.handleBlur('zip')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="phone" className="">Phone</label>
                                                <Input
                                                    id="phone"
                                                    type="text"
                                                    value={this.state.phone}
                                                    vakudutystyles="false"
                                                    onChange={this.handlePhoneChange}
                                                    name="phone"
                                                    pattern="[\(]\d{3}[\)] \d{3}[\-]\d{4}"
                                                    title="Phone Number (Format: (123) 456-7890)"
                                                    placeholder="(123) 456-7890"
                                                    onBlur={this.handleBlur('phone')}
                                                    invalid={this.state.touched.phone && !this.state.phone && this.handlePhoneChange ? true : false}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="email" className="">Email</label>
                                                <Input
                                                    id="email"
                                                    type="text"
                                                    value={this.state.email || ""}
                                                    onChange={this.handleChange}
                                                    name="email"
                                                    invalid={this.state.touched.email && this.state.email === '' ? true : false}
                                                    onBlur={this.handleBlur('email')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                            )
                                            )
                                }
                            </div>
                        </div>
                        <DialogActionsBar>
                            <div className="adjust-btns">
                                <div className="form-group">
                                    <button className="admin-k-button" onClick={this.props.cancel}>
                                        <i className="fas fa-times"></i>
                                        <span> CANCEL</span>
                                    </button>
                                    {
                                        this.state.status == 'Resolved' ?
                                            <button type="button" className="admin-k-button" onClick={this.resendEmail} style={{ width: "auto" }}>
                                                <i className="fas fa-envelope"></i>
                                                <span> Resend Email</span>
                                            </button>
                                            : ''
                                    }
                                    <button type="button" className="admin-k-button" onClick={this.handleSubmit} style={{ width: "auto" }}>
                                        <i className="fas fa-edit"></i>
                                        <span> Invite and Resolve</span>
                                    </button>
                                    <button type="button" className="admin-k-button" onClick={(event) => this.reject(event, "reject")} style={{ background: "red", width: "auto" }}>
                                        <i className="fas fa-times"></i>
                                        <span> Reject Member Request</span>
                                    </button>
                                </div>
                            </div>
                        </DialogActionsBar>
					</form>
				</Dialog>
			</div>
		);
	}
}




function mapStateToProps(state) {
    return {
        purchaseAndRenewals: state.purchaseAndRenewals,
        common: state.common,
        district: state.district,
        membership: state.membership
    };
}

export default connect(mapStateToProps, {
    setUserInfo,
    checkEmailCall,
    changeView,
    fetchStates,
    getCounties,
    fetchMembershipPackages,
    setAlert
})(MembershipRequestForm);
